module.exports = __webpack_public_path__ + "37551a59ea3ec192f03723c6690c037d.svg";